export default __webpack_public_path__ + "static/media/Westermarck Mace.4fbd80d5.jpg";